import SupportList from '../../../components/List';
function List( props ) {
    const updatedProps = {
        ...props,
        context: 'vendor',
    };
    return <SupportList { ...updatedProps } />;
}

export default List;
